export default {
  title: {
    id: 'profile_page_banking_details_tab_title',
    defaultMessage: 'Banking details',
  },
  accountNumberTitle: {
    id: 'profile_page_banking_details_tab_account_number_title',
    defaultMessage: 'Account number',
  },
  editButton: {
    id: 'profile_page_banking_details_tab_edit_button_label',
    defaultMessage: 'Edit',
  },
  routingNumberTitle: {
    id: 'profile_page_banking_details_tab_routing_number_title',
    defaultMessage: 'Routing number',
  },
  addDetailsButton: {
    id: 'profile_page_banking_details_tab_add_banking_details_button_label',
    defaultMessage: 'Add details',
  },
  bankingDetailsDescription: {
    id: 'profile_page_banking_details_tab_add_banking_details_description',
    defaultMessage: 'Here’s what you need to add:',
  },
  toDoLabel: {
    id: 'profile_page_legal_details_tab_do_do_label',
    defaultMessage: 'To do',
  },
}
